import React from 'react'
import { Box, Typography } from '@mui/material'
import { Container, Row, Col } from 'react-bootstrap'
import { useInView } from "react-intersection-observer";
import CountUp from 'react-countup';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faMapPin } from '@fortawesome/free-solid-svg-icons'
import { faPlaneArrival } from '@fortawesome/free-solid-svg-icons'  
import { faUsersRays } from '@fortawesome/free-solid-svg-icons'  
import { faNewspaper } from '@fortawesome/free-solid-svg-icons'  
import { motion } from 'framer-motion'

const Statistics = () => {
    const { ref, inView } = useInView({
        triggerOnce: true, // Runs animation only once
        threshold: 0.5,    // Starts when 30% of section is visible
      });

  return (
    <>
      <section className='relative'>
        <Box className="statsArea backOverlay">
            <Container ref={ref} >
                <Row>
                    <Col lg={3}>
                    <motion.div
                        initial={{ x: -100, opacity: 0 }}
                        whileInView={{ x: 0, opacity: 1 }}
                        exit={{ x: 100, opacity: 0 }}
                        transition={{ duration: 1, ease: "easeInOut" }}
                        viewport={{ once: false, amount: 0.2 }}
                    >

                        <Box className="stats text-center">
                            <Typography variant="body1"> {inView ? <CountUp start={0} end={19} duration={3} /> : 0}+</Typography>
                            <Typography variant="caption"  component="p"><FontAwesomeIcon icon={faMapPin} /> Locations</Typography>
                        </Box>
                    </motion.div>
                    </Col>
                    <Col lg={3}>
                    <motion.div
                        initial={{ x: -100, opacity: 0 }}
                        whileInView={{ x: 0, opacity: 1 }}
                        exit={{ x: 100, opacity: 0 }}
                        transition={{ duration: 1, ease: "easeInOut" }}
                        viewport={{ once: false, amount: 0.2 }}
                    >

                        <Box className="stats text-center">
                            <Typography variant="body1"> {inView ? <CountUp start={0} end={11} duration={2} /> : 0}+</Typography>
                            <Typography variant="caption"  component="p"><FontAwesomeIcon icon={faPlaneArrival} /> Flights</Typography>
                        </Box>
                    </motion.div>
                    </Col>
                    <Col lg={3}>
                    <motion.div
                        initial={{ x: 100, opacity: 0 }}
                        whileInView={{ x: 0, opacity: 1 }}
                        exit={{ x: 100, opacity: 0 }}
                        transition={{ duration: 1, ease: "easeInOut" }}
                        viewport={{ once: false, amount: 0.2 }}
                    >

                        <Box className="stats text-center">
                            <Typography variant="body1"> {inView ? <CountUp start={0} end={100} duration={2} /> : 0}+</Typography>
                            <Typography variant="caption"  component="p"><FontAwesomeIcon icon={faNewspaper} /> Testimonials</Typography>
                        </Box>
                    </motion.div>
                    </Col>
                    <Col lg={3}>
                    <motion.div
                        initial={{ x: 100, opacity: 0 }}
                        whileInView={{ x: 0, opacity: 1 }}
                        exit={{ x: 100, opacity: 0 }}
                        transition={{ duration: 1, ease: "easeInOut" }}
                        viewport={{ once: false, amount: 0.2 }}
                    >

                        <Box className="stats text-center">
                            <Typography variant="body1"> {inView ? <CountUp start={0} end={180} duration={2} /> : 0}+</Typography>
                            <Typography variant="caption" component="p" ><FontAwesomeIcon icon={faUsersRays} /> Experienced Staff</Typography>
                        </Box>
                    </motion.div>
                    </Col>
                </Row>
            </Container>
        </Box>
      </section>
    </>
  )
}

export default Statistics
